import { render } from "./article-card.vue?vue&type=template&id=7f8a0acc"
import script from "./article-card.vue?vue&type=script&lang=js"
export * from "./article-card.vue?vue&type=script&lang=js"

import "./article-card.vue?vue&type=style&index=0&id=7f8a0acc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__